import { render, staticRenderFns } from "./BRadio.vue?vue&type=template&id=01d92b36&"
import script from "./BRadio.vue?vue&type=script&lang=js&"
export * from "./BRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports